// Motion (motion/react) transition presets: springs for UI, linear for time.
import type { Transition } from 'motion/react';

export const springs = {
  /** Buttons, chips, small things that should feel instant. */
  snappy: { type: 'spring', stiffness: 560, damping: 34, mass: 0.8 },
  /** Celebratory entrances (points, stamps, podium blocks). */
  bouncy: { type: 'spring', stiffness: 380, damping: 17, mass: 0.9 },
  /** Panels and cards sliding between phases. */
  gentle: { type: 'spring', stiffness: 190, damping: 26 },
  /** Leaderboard rows gliding to their new places. */
  layout: { type: 'spring', stiffness: 420, damping: 38, mass: 0.9 },
} as const satisfies Record<string, Transition>;

/** Time is linear: countdown bars, progress. */
export const linear = (seconds: number): Transition => ({ type: 'tween', ease: 'linear', duration: seconds });
